export default __webpack_public_path__ + "static/SharpSansNo1-Bold-f0aef0e4f63cb83f5be795cbb6ef4481.woff";